// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ─────────────────────────────────────────────
   Existing styles kept intact
───────────────────────────────────────────── */
.close-session-swal-container {
  z-index: 1300 !important;
}

.manager-validate-btn {
  background-color: #0562fb !important;
  color: #fff !important;
  border-radius: 7px !important;
  border: 1px solid #0562fb;
  padding: 5px 15px 5px 15px !important;
}

.manager-validate-btn-disable {
  background-color: #779ddf !important;
  color: #fff !important;
  cursor: not-allowed !important;
  border-radius: 7px !important;
  padding: 5px 15px 5px 15px !important;
  opacity: 0.3;
}

/* ─────────────────────────────────────────────
   NEW Manager Modal UI
───────────────────────────────────────────── */

/* Full-screen overlay (same positioning as the old Box sx style) */
.manager-modal-overlay {
  position: fixed;
  inset: 0;
  z-index: 1200;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.5);
}

/* Card */
.manager-modal-card {
  position: relative;
  width: 100%;
  max-width: 400px;
  border-radius: 24px;
  overflow: hidden;
  box-shadow: 0 25px 60px rgba(0, 0, 0, 0.35);
  background: #fff;
}

/* ── Close button ── */
.manager-modal-close-btn {
  position: absolute;
  top: 14px;
  right: 14px;
  z-index: 10;
  background: transparent;
  border: none;
  cursor: pointer;
  color: rgba(255, 255, 255, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  border-radius: 6px;
  transition: color 0.2s;
}
.manager-modal-close-btn:hover {
  color: #fff;
}

/* ── Dark header ── */
.manager-modal-header {
  background-color: #0f172a;
  padding: 28px 24px 24px;
  text-align: center;
}

.manager-modal-lock-icon {
  width: 64px;
  height: 64px;
  background: #1e293b;
  border: 1px solid #334155;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 16px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4);
}

.manager-modal-title {
  font-size: 1.25rem;
  font-weight: 700;
  color: #fff;
  margin: 0 0 6px;
}

.manager-modal-subtitle {
  font-size: 0.8125rem;
  color: #94a3b8;
  margin: 0;
}

/* ── White body ── */
.manager-modal-body {
  background: #fff;
  padding: 24px 24px 28px;
}

/* ── Field group ── */
.manager-modal-field-group {
  margin-bottom: 18px;
}

.manager-modal-label {
  display: block;
  font-size: 0.6875rem;
  font-weight: 700;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.07em;
  margin-bottom: 8px;
}

/* ── PIN input wrapper ── */
.manager-modal-pin-wrapper .MuiInput-root,
.manager-modal-pin-wrapper .numberInput1 {
  width: 100%;
  height: 56px;
  border: 1.5px solid #e2e8f0;
  border-radius: 12px !important;
  padding: 0 14px;
  /* font-size: 1.75rem; */
  font-weight: 700;
  text-align: center;
  letter-spacing: 0.45em;
  background: #fff;
  transition:
    border-color 0.2s,
    box-shadow 0.2s;
  box-shadow: none;
}

.manager-modal-pin-wrapper .MuiInput-root:focus-within {
  border-color: #3b82f6;
  box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.1);
}

/* ── Verify & Close Session button ── */
.manager-modal-verify-btn {
  width: 100% !important;
  height: 48px !important;
  background: #2563eb !important;
  color: #fff !important;
  font-size: 1rem !important;
  font-weight: 700 !important;
  border-radius: 12px !important;
  border: none !important;
  cursor: pointer;
  box-shadow: 0 6px 20px rgba(37, 99, 235, 0.3) !important;
  transition:
    background 0.2s,
    box-shadow 0.2s,
    opacity 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 4px;
}
.manager-modal-verify-btn:hover:not(:disabled) {
  background: #1d4ed8 !important;
  box-shadow: 0 8px 24px rgba(37, 99, 235, 0.38) !important;
}
.manager-modal-verify-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* ── OR divider ── */
.manager-modal-divider {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 22px 0;
}
.manager-modal-divider-line {
  flex: 1;
  height: 1px;
  background: #f1f5f9;
}
.manager-modal-divider-text {
  font-size: 0.6875rem;
  font-weight: 600;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 0.08em;
}

/* ── Swipe card button ── */
.manager-modal-swipe-btn {
  width: 100%;
  padding: 16px 12px;
  border: 2px dashed #e2e8f0;
  border-radius: 12px;
  background: transparent;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  transition:
    border-color 0.2s,
    background 0.2s;
}
.manager-modal-swipe-btn:not(:disabled):hover {
  border-color: #93c5fd;
  background: rgba(239, 246, 255, 0.5);
}
.manager-modal-swipe-btn:disabled {
  cursor: default;
  opacity: 0.7;
}
.manager-modal-swipe-icon {
  color: #94a3b8;
  transition: color 0.2s;
}
.manager-modal-swipe-btn:hover .manager-modal-swipe-icon {
  color: #3b82f6;
}
.manager-modal-swipe-label {
  font-size: 0.75rem;
  font-weight: 700;
  color: #64748b;
  transition: color 0.2s;
}
.manager-modal-swipe-btn:hover .manager-modal-swipe-label {
  color: #2563eb;
}

/* ── Bottom action row ── */
.manager-modal-actions {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
  margin-top: 18px;
}
.manager-modal-actions--center {
  justify-content: center;
  margin-top: 14px;
}

/* ── Cancel button ── */
.manager-modal-cancel-btn {
  background: transparent !important;
  color: #64748b !important;
  font-size: 0.875rem !important;
  font-weight: 600 !important;
  border: none !important;
  cursor: pointer;
  padding: 8px 16px !important;
  border-radius: 8px !important;
  transition:
    background 0.2s,
    color 0.2s;
}
.manager-modal-cancel-btn:hover {
  background: #f1f5f9 !important;
  color: #334155 !important;
}

/* ── Submit (Next) button – cashier step ── */
.manager-modal-submit-btn {
  background: #2563eb !important;
  color: #fff !important;
  font-size: 0.875rem !important;
  font-weight: 700 !important;
  border-radius: 8px !important;
  border: none !important;
  padding: 8px 24px !important;
  cursor: pointer;
  transition:
    background 0.2s,
    opacity 0.2s;
  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.25) !important;
}
.manager-modal-submit-btn:hover {
  background: #1d4ed8 !important;
}
.manager-modal-submit-btn--disabled {
  background: #779ddf !important;
  opacity: 0.4;
  cursor: not-allowed !important;
}

/* ── Error message ── */
.err-msg-text {
  color: #ef4444;
  font-size: 0.75rem;
  margin: 6px 0 0;
}

/* ── Mobile adjustments ── */
@media (max-width: 480px) {
  .manager-modal-card {
    max-width: 100%;
    border-radius: 0;
    min-height: 100dvh;
    display: flex;
    flex-direction: column;
  }
  .manager-modal-body {
    flex: 1;
  }
}

/* ─────────────────────────────────────────────
   SweetAlert2 — custom modal (matches Manager Access style)
───────────────────────────────────────────── */

/* Outer popup card */
.swal-custom-popup {
  border-radius: 24px !important;
  overflow: hidden !important;
  padding: 0 !important;
  width: 380px !important;
  max-width: 95vw !important;
  box-shadow: 0 25px 60px rgba(0, 0, 0, 0.35) !important;
}

/* Hide the default SweetAlert2 title & icon since we render our own inside html */
.swal-custom-title-hidden {
  display: none !important;
}
.swal-custom-icon-hidden {
  display: none !important;
}

/* The html container holds our custom header block — remove its default padding */
.swal-custom-html {
  margin: 0 !important;
  padding: 0 !important;
}

/* ── Custom header injected via html option ── */
.swal-modal-header {
  background-color: #0f172a;
  padding: 28px 24px 24px;
  text-align: center;
}

.swal-modal-icon-wrap {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 16px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4);
}

.swal-modal-icon-wrap--warning {
  background: #1e293b;
  border: 1px solid #f59e0b40;
}

.swal-modal-icon-wrap--success {
  background: #1e293b;
  border: 1px solid #34d39940;
}

.swal-modal-heading {
  font-size: 1.2rem;
  font-weight: 700;
  color: #fff;
  margin: 0 0 8px;
}

.swal-modal-desc {
  font-size: 0.8125rem;
  color: #94a3b8;
  margin: 0;
  line-height: 1.5;
}

/* ── Actions row ── */
.swal-custom-actions {
  padding: 20px 24px 24px !important;
  gap: 10px !important;
  justify-content: stretch !important;
  flex-direction: column !important;
  background: #fff;
  margin: 0 !important;
}

/* ── Confirm button ── */
.swal-custom-confirm {
  width: 100% !important;
  height: 46px !important;
  background: #2563eb !important;
  color: #fff !important;
  font-size: 0.9375rem !important;
  font-weight: 700 !important;
  border-radius: 12px !important;
  border: none !important;
  cursor: pointer !important;
  box-shadow: 0 6px 20px rgba(37, 99, 235, 0.3) !important;
  transition:
    background 0.2s,
    box-shadow 0.2s !important;
  order: 1;
}
.swal-custom-confirm:hover:not(:disabled) {
  background: #1d4ed8 !important;
  box-shadow: 0 8px 24px rgba(37, 99, 235, 0.38) !important;
}

/* ── Cancel button ── */
.swal-custom-cancel {
  width: 100% !important;
  height: 46px !important;
  background: #f8fafc !important;
  color: #64748b !important;
  font-size: 0.9375rem !important;
  font-weight: 600 !important;
  border-radius: 12px !important;
  border: 1.5px solid #e2e8f0 !important;
  cursor: pointer !important;
  transition:
    background 0.2s,
    color 0.2s !important;
  order: 2;
}
.swal-custom-cancel:hover {
  background: #f1f5f9 !important;
  color: #334155 !important;
}

/* ── Validation error message ── */
.swal2-validation-message {
  border-radius: 8px !important;
  margin: 0 24px 16px !important;
  font-size: 0.8125rem !important;
}

/* ── Dropdown Select Hover Highlight ── */
.manager-auth-select div[class*="soft-select__option"]:hover,
.manager-auth-select div[class*="soft-select__option"][class*="is-focused"],
.manager-auth-select div[class*="soft-select__option"][class*="is-selected"] {
  background-color: #1ba1e2 !important;
  border-radius: 12px !important;
  margin: 4px !important;
  color: #1e293b !important;
  cursor: pointer !important;
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/all-products/components/sliderModalManger/index.css"],"names":[],"mappings":"AAAA;;+CAE+C;AAC/C;EACE,wBAAwB;AAC1B;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;EACtB,6BAA6B;EAC7B,yBAAyB;EACzB,qCAAqC;AACvC;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;EACtB,8BAA8B;EAC9B,6BAA6B;EAC7B,qCAAqC;EACrC,YAAY;AACd;;AAEA;;+CAE+C;;AAE/C,mEAAmE;AACnE;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA,SAAS;AACT;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,2CAA2C;EAC3C,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,WAAW;AACb;;AAEA,sBAAsB;AACtB;EACE,yBAAyB;EACzB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,SAAS;AACX;;AAEA,qBAAqB;AACrB;EACE,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,sBAAsB;AACtB;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA,4BAA4B;AAC5B;;EAEE,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,8BAA8B;EAC9B,eAAe;EACf,wBAAwB;EACxB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB;;mBAEiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA,wCAAwC;AACxC;EACE,sBAAsB;EACtB,uBAAuB;EACvB,8BAA8B;EAC9B,sBAAsB;EACtB,0BAA0B;EAC1B,2BAA2B;EAC3B,8BAA8B;EAC9B,uBAAuB;EACvB,eAAe;EACf,wDAAwD;EACxD;;;gBAGc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,8BAA8B;EAC9B,yDAAyD;AAC3D;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;AACA;EACE,OAAO;EACP,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA,4BAA4B;AAC5B;EACE,WAAW;EACX,kBAAkB;EAClB,0BAA0B;EAC1B,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR;;mBAEiB;AACnB;AACA;EACE,qBAAqB;EACrB,oCAAoC;AACtC;AACA;EACE,eAAe;EACf,YAAY;AACd;AACA;EACE,cAAc;EACd,sBAAsB;AACxB;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;AACA;EACE,cAAc;AAChB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,kCAAkC;EAClC,yBAAyB;EACzB,8BAA8B;EAC9B,2BAA2B;EAC3B,uBAAuB;EACvB,eAAe;EACf,4BAA4B;EAC5B,6BAA6B;EAC7B;;cAEY;AACd;AACA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA,8CAA8C;AAC9C;EACE,8BAA8B;EAC9B,sBAAsB;EACtB,8BAA8B;EAC9B,2BAA2B;EAC3B,6BAA6B;EAC7B,uBAAuB;EACvB,4BAA4B;EAC5B,eAAe;EACf;;gBAEc;EACd,yDAAyD;AAC3D;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;EAC9B,YAAY;EACZ,8BAA8B;AAChC;;AAEA,wBAAwB;AACxB;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA,6BAA6B;AAC7B;EACE;IACE,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;EACxB;EACA;IACE,OAAO;EACT;AACF;;AAEA;;+CAE+C;;AAE/C,qBAAqB;AACrB;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,qBAAqB;EACrB,uBAAuB;EACvB,0BAA0B;EAC1B,sDAAsD;AACxD;;AAEA,kFAAkF;AAClF;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;;AAEA,kFAAkF;AAClF;EACE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA,iDAAiD;AACjD;EACE,yBAAyB;EACzB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,SAAS;EACT,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE,kCAAkC;EAClC,oBAAoB;EACpB,mCAAmC;EACnC,iCAAiC;EACjC,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA,yBAAyB;AACzB;EACE,sBAAsB;EACtB,uBAAuB;EACvB,8BAA8B;EAC9B,sBAAsB;EACtB,+BAA+B;EAC/B,2BAA2B;EAC3B,8BAA8B;EAC9B,uBAAuB;EACvB,0BAA0B;EAC1B,wDAAwD;EACxD;;8BAE4B;EAC5B,QAAQ;AACV;AACA;EACE,8BAA8B;EAC9B,yDAAyD;AAC3D;;AAEA,wBAAwB;AACxB;EACE,sBAAsB;EACtB,uBAAuB;EACvB,8BAA8B;EAC9B,yBAAyB;EACzB,+BAA+B;EAC/B,2BAA2B;EAC3B,8BAA8B;EAC9B,sCAAsC;EACtC,0BAA0B;EAC1B;;yBAEuB;EACvB,QAAQ;AACV;AACA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA,mCAAmC;AACnC;EACE,6BAA6B;EAC7B,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA,0CAA0C;AAC1C;;;EAGE,oCAAoC;EACpC,8BAA8B;EAC9B,sBAAsB;EACtB,yBAAyB;EACzB,0BAA0B;AAC5B","sourcesContent":["/* ─────────────────────────────────────────────\n   Existing styles kept intact\n───────────────────────────────────────────── */\n.close-session-swal-container {\n  z-index: 1300 !important;\n}\n\n.manager-validate-btn {\n  background-color: #0562fb !important;\n  color: #fff !important;\n  border-radius: 7px !important;\n  border: 1px solid #0562fb;\n  padding: 5px 15px 5px 15px !important;\n}\n\n.manager-validate-btn-disable {\n  background-color: #779ddf !important;\n  color: #fff !important;\n  cursor: not-allowed !important;\n  border-radius: 7px !important;\n  padding: 5px 15px 5px 15px !important;\n  opacity: 0.3;\n}\n\n/* ─────────────────────────────────────────────\n   NEW Manager Modal UI\n───────────────────────────────────────────── */\n\n/* Full-screen overlay (same positioning as the old Box sx style) */\n.manager-modal-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 1200;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(0, 0, 0, 0.5);\n}\n\n/* Card */\n.manager-modal-card {\n  position: relative;\n  width: 100%;\n  max-width: 400px;\n  border-radius: 24px;\n  overflow: hidden;\n  box-shadow: 0 25px 60px rgba(0, 0, 0, 0.35);\n  background: #fff;\n}\n\n/* ── Close button ── */\n.manager-modal-close-btn {\n  position: absolute;\n  top: 14px;\n  right: 14px;\n  z-index: 10;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  color: rgba(255, 255, 255, 0.6);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 4px;\n  border-radius: 6px;\n  transition: color 0.2s;\n}\n.manager-modal-close-btn:hover {\n  color: #fff;\n}\n\n/* ── Dark header ── */\n.manager-modal-header {\n  background-color: #0f172a;\n  padding: 28px 24px 24px;\n  text-align: center;\n}\n\n.manager-modal-lock-icon {\n  width: 64px;\n  height: 64px;\n  background: #1e293b;\n  border: 1px solid #334155;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto 16px;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4);\n}\n\n.manager-modal-title {\n  font-size: 1.25rem;\n  font-weight: 700;\n  color: #fff;\n  margin: 0 0 6px;\n}\n\n.manager-modal-subtitle {\n  font-size: 0.8125rem;\n  color: #94a3b8;\n  margin: 0;\n}\n\n/* ── White body ── */\n.manager-modal-body {\n  background: #fff;\n  padding: 24px 24px 28px;\n}\n\n/* ── Field group ── */\n.manager-modal-field-group {\n  margin-bottom: 18px;\n}\n\n.manager-modal-label {\n  display: block;\n  font-size: 0.6875rem;\n  font-weight: 700;\n  color: #64748b;\n  text-transform: uppercase;\n  letter-spacing: 0.07em;\n  margin-bottom: 8px;\n}\n\n/* ── PIN input wrapper ── */\n.manager-modal-pin-wrapper .MuiInput-root,\n.manager-modal-pin-wrapper .numberInput1 {\n  width: 100%;\n  height: 56px;\n  border: 1.5px solid #e2e8f0;\n  border-radius: 12px !important;\n  padding: 0 14px;\n  /* font-size: 1.75rem; */\n  font-weight: 700;\n  text-align: center;\n  letter-spacing: 0.45em;\n  background: #fff;\n  transition:\n    border-color 0.2s,\n    box-shadow 0.2s;\n  box-shadow: none;\n}\n\n.manager-modal-pin-wrapper .MuiInput-root:focus-within {\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.1);\n}\n\n/* ── Verify & Close Session button ── */\n.manager-modal-verify-btn {\n  width: 100% !important;\n  height: 48px !important;\n  background: #2563eb !important;\n  color: #fff !important;\n  font-size: 1rem !important;\n  font-weight: 700 !important;\n  border-radius: 12px !important;\n  border: none !important;\n  cursor: pointer;\n  box-shadow: 0 6px 20px rgba(37, 99, 235, 0.3) !important;\n  transition:\n    background 0.2s,\n    box-shadow 0.2s,\n    opacity 0.2s;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: 4px;\n}\n.manager-modal-verify-btn:hover:not(:disabled) {\n  background: #1d4ed8 !important;\n  box-shadow: 0 8px 24px rgba(37, 99, 235, 0.38) !important;\n}\n.manager-modal-verify-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* ── OR divider ── */\n.manager-modal-divider {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin: 22px 0;\n}\n.manager-modal-divider-line {\n  flex: 1;\n  height: 1px;\n  background: #f1f5f9;\n}\n.manager-modal-divider-text {\n  font-size: 0.6875rem;\n  font-weight: 600;\n  color: #94a3b8;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n}\n\n/* ── Swipe card button ── */\n.manager-modal-swipe-btn {\n  width: 100%;\n  padding: 16px 12px;\n  border: 2px dashed #e2e8f0;\n  border-radius: 12px;\n  background: transparent;\n  cursor: pointer;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  transition:\n    border-color 0.2s,\n    background 0.2s;\n}\n.manager-modal-swipe-btn:not(:disabled):hover {\n  border-color: #93c5fd;\n  background: rgba(239, 246, 255, 0.5);\n}\n.manager-modal-swipe-btn:disabled {\n  cursor: default;\n  opacity: 0.7;\n}\n.manager-modal-swipe-icon {\n  color: #94a3b8;\n  transition: color 0.2s;\n}\n.manager-modal-swipe-btn:hover .manager-modal-swipe-icon {\n  color: #3b82f6;\n}\n.manager-modal-swipe-label {\n  font-size: 0.75rem;\n  font-weight: 700;\n  color: #64748b;\n  transition: color 0.2s;\n}\n.manager-modal-swipe-btn:hover .manager-modal-swipe-label {\n  color: #2563eb;\n}\n\n/* ── Bottom action row ── */\n.manager-modal-actions {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 10px;\n  margin-top: 18px;\n}\n.manager-modal-actions--center {\n  justify-content: center;\n  margin-top: 14px;\n}\n\n/* ── Cancel button ── */\n.manager-modal-cancel-btn {\n  background: transparent !important;\n  color: #64748b !important;\n  font-size: 0.875rem !important;\n  font-weight: 600 !important;\n  border: none !important;\n  cursor: pointer;\n  padding: 8px 16px !important;\n  border-radius: 8px !important;\n  transition:\n    background 0.2s,\n    color 0.2s;\n}\n.manager-modal-cancel-btn:hover {\n  background: #f1f5f9 !important;\n  color: #334155 !important;\n}\n\n/* ── Submit (Next) button – cashier step ── */\n.manager-modal-submit-btn {\n  background: #2563eb !important;\n  color: #fff !important;\n  font-size: 0.875rem !important;\n  font-weight: 700 !important;\n  border-radius: 8px !important;\n  border: none !important;\n  padding: 8px 24px !important;\n  cursor: pointer;\n  transition:\n    background 0.2s,\n    opacity 0.2s;\n  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.25) !important;\n}\n.manager-modal-submit-btn:hover {\n  background: #1d4ed8 !important;\n}\n.manager-modal-submit-btn--disabled {\n  background: #779ddf !important;\n  opacity: 0.4;\n  cursor: not-allowed !important;\n}\n\n/* ── Error message ── */\n.err-msg-text {\n  color: #ef4444;\n  font-size: 0.75rem;\n  margin: 6px 0 0;\n}\n\n/* ── Mobile adjustments ── */\n@media (max-width: 480px) {\n  .manager-modal-card {\n    max-width: 100%;\n    border-radius: 0;\n    min-height: 100dvh;\n    display: flex;\n    flex-direction: column;\n  }\n  .manager-modal-body {\n    flex: 1;\n  }\n}\n\n/* ─────────────────────────────────────────────\n   SweetAlert2 — custom modal (matches Manager Access style)\n───────────────────────────────────────────── */\n\n/* Outer popup card */\n.swal-custom-popup {\n  border-radius: 24px !important;\n  overflow: hidden !important;\n  padding: 0 !important;\n  width: 380px !important;\n  max-width: 95vw !important;\n  box-shadow: 0 25px 60px rgba(0, 0, 0, 0.35) !important;\n}\n\n/* Hide the default SweetAlert2 title & icon since we render our own inside html */\n.swal-custom-title-hidden {\n  display: none !important;\n}\n.swal-custom-icon-hidden {\n  display: none !important;\n}\n\n/* The html container holds our custom header block — remove its default padding */\n.swal-custom-html {\n  margin: 0 !important;\n  padding: 0 !important;\n}\n\n/* ── Custom header injected via html option ── */\n.swal-modal-header {\n  background-color: #0f172a;\n  padding: 28px 24px 24px;\n  text-align: center;\n}\n\n.swal-modal-icon-wrap {\n  width: 64px;\n  height: 64px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto 16px;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4);\n}\n\n.swal-modal-icon-wrap--warning {\n  background: #1e293b;\n  border: 1px solid #f59e0b40;\n}\n\n.swal-modal-icon-wrap--success {\n  background: #1e293b;\n  border: 1px solid #34d39940;\n}\n\n.swal-modal-heading {\n  font-size: 1.2rem;\n  font-weight: 700;\n  color: #fff;\n  margin: 0 0 8px;\n}\n\n.swal-modal-desc {\n  font-size: 0.8125rem;\n  color: #94a3b8;\n  margin: 0;\n  line-height: 1.5;\n}\n\n/* ── Actions row ── */\n.swal-custom-actions {\n  padding: 20px 24px 24px !important;\n  gap: 10px !important;\n  justify-content: stretch !important;\n  flex-direction: column !important;\n  background: #fff;\n  margin: 0 !important;\n}\n\n/* ── Confirm button ── */\n.swal-custom-confirm {\n  width: 100% !important;\n  height: 46px !important;\n  background: #2563eb !important;\n  color: #fff !important;\n  font-size: 0.9375rem !important;\n  font-weight: 700 !important;\n  border-radius: 12px !important;\n  border: none !important;\n  cursor: pointer !important;\n  box-shadow: 0 6px 20px rgba(37, 99, 235, 0.3) !important;\n  transition:\n    background 0.2s,\n    box-shadow 0.2s !important;\n  order: 1;\n}\n.swal-custom-confirm:hover:not(:disabled) {\n  background: #1d4ed8 !important;\n  box-shadow: 0 8px 24px rgba(37, 99, 235, 0.38) !important;\n}\n\n/* ── Cancel button ── */\n.swal-custom-cancel {\n  width: 100% !important;\n  height: 46px !important;\n  background: #f8fafc !important;\n  color: #64748b !important;\n  font-size: 0.9375rem !important;\n  font-weight: 600 !important;\n  border-radius: 12px !important;\n  border: 1.5px solid #e2e8f0 !important;\n  cursor: pointer !important;\n  transition:\n    background 0.2s,\n    color 0.2s !important;\n  order: 2;\n}\n.swal-custom-cancel:hover {\n  background: #f1f5f9 !important;\n  color: #334155 !important;\n}\n\n/* ── Validation error message ── */\n.swal2-validation-message {\n  border-radius: 8px !important;\n  margin: 0 24px 16px !important;\n  font-size: 0.8125rem !important;\n}\n\n/* ── Dropdown Select Hover Highlight ── */\n.manager-auth-select div[class*=\"soft-select__option\"]:hover,\n.manager-auth-select div[class*=\"soft-select__option\"][class*=\"is-focused\"],\n.manager-auth-select div[class*=\"soft-select__option\"][class*=\"is-selected\"] {\n  background-color: #1ba1e2 !important;\n  border-radius: 12px !important;\n  margin: 4px !important;\n  color: #1e293b !important;\n  cursor: pointer !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
